import { render, staticRenderFns } from "./user-wizard-property.vue?vue&type=template&id=5cec6d26&scoped=true"
import script from "./user-wizard-property.vue?vue&type=script&lang=js"
export * from "./user-wizard-property.vue?vue&type=script&lang=js"
import style0 from "./user-wizard-property.vue?vue&type=style&index=0&id=5cec6d26&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cec6d26",
  null
  
)

export default component.exports